<template>
  <div>
    <template v-if="!showMemberList">
      <div class="text-xs-right mb-2">
        <v-btn dark outline color="primary" @click="handleExportXlsx">
          <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
        </v-btn>
        <v-btn dark depressed color="primary" @click="showCampaignDialog = true">
          <v-icon>add</v-icon>&nbsp;{{ $t('Add') }}
        </v-btn>
      </div>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template #items="props">
          <tr>
            <td>{{ props.item.name }}</td>
            <td class="text-xs-center">{{ props.item.sum_point || '-' }}</td>
            <td>{{ props.item.created_at | DateFormat('DD/MM/YYYY') }}</td>
            <td>{{ props.item.updated_at | DateFormat('DD/MM/YYYY') }}</td>
            <td>{{ props.item.updated_by }}</td>
            <td>
              <v-btn color="primary" depressed small @click="handleShowUser(props.item)">
                View
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="text-xs-right mt-2">
        <v-pagination
          v-model="pageNumber"
          :total-visible="15"
          :length="pagelength"
          @input="handleChangePage"
        ></v-pagination>
      </div>
    </template>
    <template v-else>
      <CampaignMemberList
        v-if="selectedCampaign"
        v-model="selectedCampaign"
        @back="handleBackPage"
      ></CampaignMemberList>
    </template>

    <v-dialog v-model="showCampaignDialog" persistent width="500px">
      <CampaignManageDialog
        v-if="showCampaignDialog"
        @close="showCampaignDialog = false"
        @success="handleSuccessCreated"
      ></CampaignManageDialog>
    </v-dialog>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx'
import CampaignMemberList from './CampaignMemberList'
import CampaignManageDialog from './CampaignManageDialog'
import moment from 'moment'

export default {
  components: {
    importxlsx,
    exportxlsx,
    CampaignMemberList,
    CampaignManageDialog
  },
  data() {
    return {
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      importloading: false,
      pagination: { rowsPerPage: -1, sortBy: '' },
      items: [],
      exportloading: false,
      headers: [
        { text: 'ชื่อแคมเปญ', value: 'name', sortable: false },
        { text: 'คะแนนทั้งหมดที่ให้ลูกค้า', align: 'center', value: 'sum_point', sortable: false },
        { text: 'วันที่สร้าง', value: 'created_at', sortable: false },
        { text: 'วันที่อัปเดตล่าสุด', value: 'updated_at', sortable: false },
        { text: 'ชื่อแอดมิน', value: 'updated_by', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      selectedCampaign: null,
      showMemberList: false,
      showCampaignDialog: false,
      isExport: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.handleGetCampaign()
  },
  methods: {
    async handleGetCampaign() {
      const vm = this
      try {
        const response = await vm.getCampaign()
        if (response && response.status === 200) {
          vm.items = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getCampaign() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.total : vm.limit
        const data = {
          page_id: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset
        }

        vm.$store.dispatch('loading')
        const response = await toaCrmApi.getCampaign({ config: { params: data } })
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    handleShowUser(item) {
      const vm = this
      try {
        vm.selectedCampaign = {
          id: item.id,
          name: item.name
        }
        vm.showMemberList = true
      } catch (error) {
        console.error(error)
      }
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.isExport = true
        const response = await vm.getCampaign()
        const requestData = response.data.data
        vm.isExport = false

        if (requestData == null) return
        const requests = requestData.map((el) => {
          return {
            name: el.name,
            sum_point: el.sum_point,
            created_at: moment(el.created_at).format('DD/MM/YYYY'),
            updated_at: moment(el.updated_at).format('DD/MM/YYYY'),
            updated_by: el.updated_by
          }
        })

        const heading = [
          [
            'ชื่อแคมเปญ',
            'คะแนนทั้งหมดที่ให้ลูกค้า',
            'วันที่สร้าง',
            'วันที่อัปเดตล่าสุด',
            'ชื่อแอดมิน'
          ]
        ]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `campaign-member-list.xlsx`)
      } catch (error) {
        console.error(error)
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.handleGetCampaign()
      }
    },
    handleBackPage() {
      this.selectedCampaign = null
      this.showMemberList = false
      this.handleGetCampaign()
    },
    handleSuccessCreated(item) {
      this.showCampaignDialog = false
      this.handleShowUser(item)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/Campaign.vue